<template>
    <div>
        <div class="results">
            <div class="errors" v-if="errors.length">
                <div v-for="error in errors" :key="error">
                    <b-alert class="mt-4 mb-4" show variant="danger">
                        {{ error.code }} {{ error.title }}
                    </b-alert >
                </div>
            </div>
            <div v-else-if="results.length">
                <div class="row no-gutters item"
                    v-for="result in results" 
                    :key="result.hotel.hotelId"
                    :id="result.hotel.hotelId"
                >
                    <b-col sm="12" md="5">
                        <HotelImage :result="result" />
                    </b-col>
                    <b-col sm="12" md="7">
                        <div class="h-wrap">
                            <StarRating :result="result" />
                            <h3 class="hotel-title display-3 mb-0">
                                <router-link target='_blank' :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(result.hotel.name) + '/' + toHex(result.hotel.hotelId), query: $route.query }">
                                    {{ result.hotel.name }}
                                </router-link>
                            </h3>
                            <ul class="address-line list-unstyled">
                                <li>{{ capitalize(result.hotel.address.cityName) }}</li>
                                <li>{{ result.hotel.hotelDistance.distance }} {{ result.hotel.hotelDistance.distanceUnit }} from {{ $route.query.search }}</li>
                            </ul>
                            <!--
                            <star-rating
                                v-model="result.hotel.rating"
                                :read-only="true"
                                :star-size="20"
                                :show-rating="false">
                            </star-rating>
                            -->
                            <div>
                                <div class="rooms">
                                    <b-row class="room" v-for="offer in result.offers" :key="offer.id">
                                        <b-col md="6">
                                            <Room :offer="offer"/>
                                        </b-col>
                                        <b-col md="6" class="text-right">
                                            <Price :exchangerates="exchangerates" :offer="offer" />
                                            <b-button variant="primary" target='_blank' :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(result.hotel.name) + '/' + toHex(result.hotel.hotelId), query: $route.query }">
                                                See availability
                                            </b-button>
                                        </b-col> 
                                    </b-row>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </div>
            </div>
            <div v-else>
                <div class="row no-gutters item" v-for="index in 3" :key="index">
                    <b-col sm="12" md="5">
                        <content-placeholders>
                            <content-placeholders-img style="height:250px;"/>
                        </content-placeholders>
                    </b-col>
                    <b-col sm="12" md="7">
                        <div class="h-wrap">
                            <content-placeholders :rounded="true" :centered="true">
                                <content-placeholders-heading/>
                                <content-placeholders-text :lines="4"/>
                            </content-placeholders>
                        </div>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Price from '@/components/ui/Price'
    import Room from '@/components/ui/Room'
    import StarRating from '@/components/ui/StarRating'
    import HotelImage from '@/components/ui/HotelImage'

    export default {
        name: 'HotelResults',
        components: {
            Price,
            Room,
            HotelImage,
            StarRating,
        },
        props: {
            errors: {
                type: Array,
                required: true
            },
            results: {
                type: Array,
                required: true
            },
            search: {
                type: Object,
                required: true
            },
            exchangerates: {
                type: Object,
                required: true
            }
        },
        methods: {
            convertToSlug(text) {
                return text
                    .toLowerCase()
                    .replace(/[^\w ]+/g,'')
                    .replace(/ +/g,'-')
                ;
            },
            toHex(a) {
                var s = unescape(encodeURIComponent(a))
                var h = ''
                for (var i = 0; i < s.length; i++) {
                    h += s.charCodeAt(i).toString(16)
                }
                return h
            },
            capitalize(s) {
                if (typeof s !== 'string') return '';
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            }
        },
    }
</script>

<style scoped>
    .address-line{
        display:block;
        font-size:0.8rem;
    }
    .address-line li{
        display:inline-block;
    }
    .address-line li:after{
        content: '●';
        margin: 0 5px;
        color: #bdbdbd;
        font-size: 10px;
        position: relative;
        top: -1px;
    }
    .address-line li:last-child:after{
        display:none;
    }

    .h-wrap{
        padding:15px;
    }
    .results .item {
        margin-bottom: 15px;
        background-color: #fff;
    }
</style>